/*
  This file contains API calls for saved sections.
  It contains the following functions:
  - saveSectionApi: Save a section to the saved sections list.
  - getSavedSectionsApi: Get the saved sections list.
  - injectSectionApi: Inject a section into a target checklist.
  - getSavedSectionById: Get a saved section by its ID.
*/

import config from 'config/index';
import { LOCALSTORAGE_KEYS } from 'utils/globalVariable';
import { callApi, getHotelId, getItem } from 'utils/globalFunction';

// Save a section to the saved sections list.
export const saveSectionApi = async (
  sectionId: string,
  sectionName: string,
  payload: {
    isStarred: boolean;
  },
): Promise<any> => {
  try {
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/checklistSections/${sectionId}/star`,
      payload,
      'put',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      payload?.isStarred
        ? `${sectionName} saved to section library`
        : `${sectionName} removed from section library`,
      true,
      '',
      false,
    );

    if (response !== null) {
      return response?.data ? response.data : null;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};

// Get the saved sections list.
export const getSavedSectionsApi = async (): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const response = await callApi(
      config.REACT_APP_BASE_URL +
        `task/workspaces/${hotelId}/checklistSections/saved`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
      '',
      false,
    );

    if (response !== null) {
      return response?.data ? response.data : null;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};

// Inject a section into a target checklist.
export const injectSectionApi = async (payload: {
  targetChecklistId: string;
  sectionIds: string[];
}): Promise<any> => {
  try {
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/checklistSections/clone`,
      payload,
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
      '',
      false,
    );

    if (response !== null) {
      return response?.data ? response.data : null;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};

// Get a saved section by its ID.
export const getSavedSectionById = async (id): Promise<any> => {
  try {
    const response = await callApi(
      config.REACT_APP_BASE_URL + `task/checklistSections/${id}`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
      '',
      false,
    );

    if (response !== null) {
      return response?.data ? response.data : null;
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
};
